/**
 * Layering and timing for the drop feedback shown while a pragmatic drop's API
 * call + refetch resolve — the "frozen drop" preview, the loading overlay, and
 * the per-column loading state. Kept in one place so the values that only work
 * as a set can't drift apart.
 */

/** One level below the overlay, so the overlay renders over the preview. */
export const FROZEN_DROP_PREVIEW_Z_INDEX = 59;
export const DROP_LOADING_OVERLAY_Z_INDEX = 60;

/**
 * How long loading has to stay idle before a finished operation's drop feedback
 * is cleared. The response and the GET it triggers are two loading cycles with a
 * gap between them; clearing inside that gap snaps the card back to its old
 * position. Shared by `useFrozenDrop` and `useColumnLoading` on purpose — they
 * cover the same drop and have to clear on the same frame.
 */
export const SETTLE_GRACE_MS = 50;

/**
 * Hard cap on how long one operation may hold its drop feedback while the view
 * sits idle. Every terminal path releases explicitly, but single-slot state
 * around this flow (e.g. two responses overwriting each other in
 * `dialogManagerActiveAtom`) can still strand one, leaving a card copy over the
 * board and its columns un-droppable until the view remounts.
 */
export const MAX_HOLD_MS = 30_000;

/**
 * How soon the watchdog looks again after finding the operation still
 * legitimately busy, so recovery follows the hold instead of waiting out another
 * full `MAX_HOLD_MS`.
 */
export const WATCHDOG_RECHECK_MS = 1_000;
